import CategoryList from '@/pages/setup/provider_categories/components/CategoryList.tsx'
import MultiQueryPageLoader from '@/common/components/MultiQueryPageLoader.tsx'
import { useProviderCategories } from '@/queries/providers/categories/hooks.ts'

const ProviderCategoriesPage = () => {
  const { query: categoriesQuery, invalidateQuery: invalidateCategories } =
    useProviderCategories()

  const handleCategoryChange = () => invalidateCategories()

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={[categoriesQuery] as const}
    >
      {([categories]) => {
        return (
          <CategoryList
            invalidateCategories={invalidateCategories}
            categories={categories}
            onCategoryChange={handleCategoryChange}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
export default ProviderCategoriesPage
